var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeroheight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76772 0L5.53653 3.74296H2L3.76772 0ZM2 4.3343H5.53653V21.0812H2V4.3343ZM2 21.6726H5.53653V23.7087H2V21.6726ZM10.7415 1.30289L22 12.4928L10.6848 24L8.23991 21.6931L17.1276 12.509L8.29226 3.7343L10.7415 1.30289Z",
    fill: "url(#paint0_linear_46_12996)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_12996",
    x1: 5.1276,
    y1: 24,
    x2: 22.472,
    y2: 2.96854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC407A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroheight);
export default __webpack_public_path__ + "static/media/zeroheight.b2c2e908f7229e3b98ee25338d4ac522.svg";
export { ForwardRef as ReactComponent };